import React, { useContext } from 'react';
import FaradayLogo from 'Images/faraday-logo.svg';
import FaradayLogoDark from 'Images/faraday-logo-dark.svg';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import {
  Wrapper, PrimaryTitle, TertiaryTitle, Text, Row, Button, Logo, Container
} from '../../styled';
import { useSelector } from 'react-redux';
import { selectApiVersion } from 'store/Config/selector';
import { ThemeContext } from 'Context';

const About = ({ onClose }) => {
  const intl = useIntl();
  const apiVersion = useSelector(selectApiVersion);
  const { theme } = useContext(ThemeContext);
  const isDark = theme === 'dark';

  return (
    <Wrapper maxWidth="480px">
      <Logo src={ isDark ? FaradayLogoDark : FaradayLogo } alt="Faraday" />
      <PrimaryTitle>
        {intl.formatMessage({ id: 'user.about.title' })} {apiVersion.split('c-').join('').split('p-').join('')}
      </PrimaryTitle>

      <Row>
        <Text>
          {intl.formatMessage({ id: 'user.about.text' })}
        </Text>
      </Row>

      <Container>
        <Row>
          <TertiaryTitle href="https://faradaysec.com/blog/?id=index-440370&ucat=165" target="_blank">
            {intl.formatMessage({ id: 'user.about.tertiary-title.new' })}
          </TertiaryTitle>
        </Row>

        <Row>
          <TertiaryTitle href="https://github.com/infobyte/faraday/blob/master/AUTHORS" target="_blank">
            {intl.formatMessage({ id: 'user.about.tertiary-title.credits' })}
          </TertiaryTitle>
        </Row>

        <Row>
          <TertiaryTitle href="https://docs.faradaysec.com" target="_blank">
            {intl.formatMessage({ id: 'user.about.tertiary-title.documentation' })}
          </TertiaryTitle>
        </Row>

      </Container>
      <Button onClick={ onClose }>{intl.formatMessage({ id: 'user.buttton' })}</Button>
    </Wrapper>
  );
};

About.propTypes = {
  onClose: PropTypes.func.isRequired
};

export default About;
